module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0"
  }, [(!_vm.hasResetRequest) ? _c('v-form', {
    staticClass: "pl-4 pr-4 pt-4 pb-4 noPaddingTopBottom"
  }, [_c('p', [_c('br'), _vm._v("Enter the email associated to the account, as well as your new password.")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Email Address:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Account email to reset",
      "rules": _vm.emailRule,
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.fPassEmail),
      callback: function($$v) {
        _vm.fPassEmail = $$v
      },
      expression: "fPassEmail"
    }
  })], 1), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "display": "inline !important"
    }
  }, [_vm._v("New Password:")]), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-checkbox",
    staticStyle: {
      "display": "inline !important",
      "float": "right"
    }
  }, [_c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "checkbox-1"
    }
  }, [_vm._v("Show password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-1"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "type": _vm.checked ? 'text' : 'password',
      "label": "New Password",
      "rules": _vm.fPassRules,
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.fPassPass),
      callback: function($$v) {
        _vm.fPassPass = $$v
      },
      expression: "fPassPass"
    }
  }), _vm._v(" "), _c('password', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "badge": false,
      "toggle": true,
      "secureLength": 8,
      "strengthMeterOnly": true
    },
    model: {
      value: (_vm.fPassPass),
      callback: function($$v) {
        _vm.fPassPass = $$v
      },
      expression: "fPassPass"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Your password must contain:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "14px"
    }
  }, [_c('small', {
    class: _vm.has_uppercase ? 'green--text' : 'red--text'
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.has_uppercase ? 'green darken-2' : 'red darken-2'
    }
  }, [_vm._v(_vm._s(_vm.has_uppercase ? 'check' : 'close'))]), _vm._v("\n\t\t\t\t\t\t\t\tAt least 1 capital letter\n\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    class: _vm.has_number ? 'green--text' : 'red--text'
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.has_number ? 'green darken-2' : 'red darken-2'
    }
  }, [_vm._v(_vm._s(_vm.has_number ? 'check' : 'close'))]), _vm._v("\n\t\t\t\t\t\t\t\tAt least 1 number\n\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    class: _vm.has_maximum_length ? 'green--text' : 'red--text'
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.has_maximum_length ? 'green darken-2' : 'red darken-2'
    }
  }, [_vm._v(_vm._s(_vm.has_maximum_length ? 'check' : 'close'))]), _vm._v("\n\t\t\t\t\t\t\t\tMinimum of 8 characters\n\t\t\t\t\t\t\t")], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.requestSent) ? _c('v-btn', {
    staticClass: "text-xs-right fPassButton",
    attrs: {
      "color": "success",
      "disabled": !_vm.hasRequestedCode
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncRequestCode.apply(null, arguments)
      }
    }
  }, [_vm._v("Request Reset Code")]) : _vm._e(), _vm._v(" "), (!_vm.requestSent) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.requestSent) ? _c('v-progress-circular', {
    staticClass: "pt-3 customLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasResetRequest) ? _c('v-form', {
    staticClass: "hide pl-4 pr-4 pt-4 pb-4 noPaddingTopBottom",
    model: {
      value: (_vm.hasResetPassword),
      callback: function($$v) {
        _vm.hasResetPassword = $$v
      },
      expression: "hasResetPassword"
    }
  }, [_c('br'), _vm._v(" "), (!_vm.hasCodeEmailed) ? _c('p', [_vm._v("Select your account.")]) : _c('p', [_vm._v("Enter the code that has been emailed to you")]), _vm._v(" "), (!_vm.hasCodeEmailed) ? _c('v-select', {
    attrs: {
      "items": _vm.userAccountList,
      "label": "Select Account",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncSendCode()
      }
    },
    model: {
      value: (_vm.fPassAccount),
      callback: function($$v) {
        _vm.fPassAccount = $$v
      },
      expression: "fPassAccount"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasCodeEmailed) ? _c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Reset Code",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.fPassCode),
      callback: function($$v) {
        _vm.fPassCode = $$v
      },
      expression: "fPassCode"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasCodeEmailed && !_vm.resetSent) ? _c('v-btn', {
    staticClass: "text-xs-right fPassButton",
    attrs: {
      "color": "success",
      "disabled": !_vm.hasCodeEmailed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncResetPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset Password")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.resetSent) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}